import {
  CarHealthApi, CarHealth, // eslint-disable-line no-unused-vars
} from '@clients/bff'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'

let basePath = getBasePath()

export default class ExtendedCarHealthApi extends CarHealthApi {
  getStatistics (vehicleId?: number, options?: any): AxiosPromise<CarHealth> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getCarHealth(vehicleId, optionsParam)
  }
}
